import { RootState } from "../../app/store";
import { classNames } from "../../utils/utils";
import { useLocation, useNavigate } from "react-router-dom";
import { useWindowDimensions } from "../../utils/utils";
import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  Favorite,
  ShoppingCartSharp,
  DoneSharp,
  Edit,
  VisibilityOffSharp,
  DeleteForever,
  MoreHoriz,
  VisibilitySharp,
} from "@mui/icons-material";
import {
  dismissUpSalesModal,
  setActiveProduct,
  toggleDeleteProductModal,
  toggleEditProductModal,
  toggleHideProductModal,
} from "../../features/products/productsSlice";

interface Props {
  product: any;
  handleOnClick?: boolean;
}

const Card = (props: Props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { width } = useWindowDimensions();

  const [state, setState] = useState({
    grid: false,
    loaded: false,
    activeLink: "/",
  });

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      activeLink: location.pathname.replace(/^\/+|\/+$/g, ""),
    }));
  }, [location, state.activeLink]);

  const imageRef = useRef<HTMLImageElement>(null);

  const isInfoVisible = useAppSelector(
    (state: RootState) => state.utils.isInfoVisible
  );

  const isGridViewActive = useAppSelector(
    (state: RootState) => state.utils.isGridViewActive
  );

  const getRowSpanEstimate = (width, height) => {
    if (height === width) {
      return 4;
    }
    if (width < height) {
      if (width < 640) {
        return 6;
      }
      return 4;
    }
    if (width > height) {
      return 2;
    }
  };

  const onClickHandler = (product) => {
    switch (product?._id) {
      case "6429948d17f015be43b52af1":
        navigate("/lapaix");
        break;
      case "6a71f32b3684d4971acfb615":
        navigate("/bigman");
        break;
      case "66841f6d2d2d08dfc58d7374":
        navigate("/jjl60mn");
        break;
      case "67e13ac7cb9c3dd784e8cc01":
        navigate("/viga");
        break;
      case "6429962817f015be43b52b1b":
        navigate("/attote");
        break;
      case "66841dcc2d2d08dfc58d7366":
        navigate("/serumvisage");
        break;
      case "69e9f8be825caf554441d20e":
        navigate("/minoxidil");
        break;
      case "6429962817f015be43b52b1b":
        navigate("/macacurve");
        break;
      case "66841e3c2d2d08dfc58d736b":
        navigate("/lxrmimi");
        break;
      case "66841f152d2d08dfc58d7370":
        navigate("/lanbena");
        break;
      case "66841bab2d2d08dfc58d7342":
        navigate("/hairnownow");
        break;
      case "6684185c2d2d08dfc58d731e":
        navigate("/fittea");
        break;
      case "66841b202d2d08dfc58d733d":
        navigate("/disaar");
        break;
      case "66841adb2d2d08dfc58d7338":
        navigate("/damatol");
        break;
      case "66841c362d2d08dfc58d7347":
        navigate("/antipoil");
        break;
      case "66841d222d2d08dfc58d7361":
        navigate("/hairremoval");
        break;
      case "689688cd74c5a7be0001929e":
        navigate("/shilajit");
        break;
      case "68c0ae6ab9a01d13bd15c9d1":
        navigate("/patchdetox");
        break;
      case "68d2a91b1c0fde807d6022e6":
        navigate("/maitypommade");
        break;
      case "68d2aa374b32565312635ffb":
        navigate("/maityserum");
        break;
      case "68a892a9ab7b543b43832558":
        navigate("/maitypousse");
        break;

      default:
        break;
    }
    dispatch(dismissUpSalesModal());
  };

  const getColumnSpanEstimate = (width, height) => {
    if (width === height) {
      return 4;
    }

    if (width < height) {
      if (width === 640) {
        return 4;
      }
      return 4;
    }

    if (width > height) {
      return 4;
    }
  };

  const ImageGridItem = (product) => {
    return (
      <img
        onLoad={() => {
          setState((prevState) => ({
            ...prevState,
            loaded: true,
          }));
        }}
        onClick={() => onClickHandler(product)}
        src={product?.images[0]?.lg}
        ref={imageRef}
        alt={product?.name}
        loading="lazy"
        className={state.loaded ? "card-img" : "card-img bg-gray-100"}
      />
    );
  };

  return (
    <figure className={classNames("product-list-item border rounded")}>
      {ImageGridItem(props.product)}
    </figure>
  );
};

export default Card;
